import { render, staticRenderFns } from "./SettingsLayoutMobile.vue?vue&type=template&id=7618b976"
import script from "./SettingsLayoutMobile.vue?vue&type=script&lang=js"
export * from "./SettingsLayoutMobile.vue?vue&type=script&lang=js"
import style0 from "./SettingsLayoutMobile.vue?vue&type=style&index=0&id=7618b976&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports